module.exports = __webpack_public_path__ + "img/collect-icon-audio-select.07992a96.svg";